export default "__VITE_PUBLIC_ASSET__1ccb36d6__"